import { createAction, props } from '@ngrx/store';
import { ChatMessage } from '../../interfaces/chat-message.interface';

export const CreateChatSession = createAction('[AI Chat] Create Chat Session');
export const CreateChatSessionSuccess = createAction('[AI Chat] Create Chat Session Success', props<{ token: string }>());
export const CreateChatSessionFail = createAction('[AI Chat] Create Chat Session Fail', props<{ error: Error }>());

export const SendMessage = createAction('[AI Chat] Send Message', props<{ message: ChatMessage }>());
export const SendMessageSuccess = createAction('[AI Chat] Send Message Success', props<{ response: ChatMessage }>());
export const SendMessageFail = createAction('[AI Chat] Send Message Fail', props<{ error: Error }>());

export const CloseChatSession = createAction('[AI Chat] Close Chat Session', props<{ isReset: boolean }>());
export const CloseChatSessionSuccess = createAction('[AI Chat] Close Chat Session Success', props<{ isReset: boolean }>());
export const CloseChatSessionFail = createAction('[AI Chat] Close Chat Session Fail', props<{ error: Error }>());
